import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Modal, Row, Table, Tag, Typography, Divider } from "antd";
import { useEffect, useState } from "react";
import { InputPreco } from "../../components";
import { useStateValue } from "../../state";

export default function TabDatelheFisicoProduto({ formulario }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();

    return (
        <div>
            <Row align="middle">
                <Col span={24}>
                    <Typography.Title level={3}>
                        <img src={require("../../assets/i-detalheProduto.png")} alt="Detalhes Físicos do Produto" />  Detalhes Físicos do Produto
                    </Typography.Title>
                    <Divider orientation="left" plain> Detalhes Físicos do Produto</Divider>
                </Col>
                <Col span={24}>
                    <Row gutter={[16, 0]}>
                        <Col>
                            <InputPreco
                                label="Peso Bruto"
                                placeholder="Peso Bruto"
                                name="pdf_pesobruto"
                                precision={3} />
                        </Col>
                        <Col>
                            <InputPreco
                                label="Peso Liquido"
                                placeholder="Peso Liquido"
                                name="pdf_pesoliquido"
                                precision={3} />
                        </Col>
                        <Col>
                            <InputPreco
                                label="Largura"
                                placeholder="Largura"
                                name="pdf_largura"
                                precision={3} />
                        </Col>
                        <Col>
                            <InputPreco
                                label="Altura"
                                placeholder="Altura"
                                name="pdf_altura"
                                precision={3} />
                        </Col>
                        <Col>
                            <InputPreco
                                label="Comprimento"
                                placeholder="Comprimento"
                                name="pdf_comprimento"
                                precision={3} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );

}